import { ChatMeta } from "@interfaces/chat";

interface Raw {
  data: {
    chat_uuid: string;
    chat_name: string;
  }[];
}

export function transformChats(raw: unknown): ChatMeta[] {
  const data = (raw as Raw).data;

  return data.map((item) => ({
    uuid: item.chat_uuid,
    name: item.chat_name,
  }));
}

